import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchLabel: {
		id: 'jql-editor.ui.jql-editor-controls-content.search.label',
		defaultMessage: 'Search',
		description: 'Label to show for the search icon which the user can press to perform a search.',
	},
});
